/**
 * @generated SignedSource<<f110ce5d9b7f154b41206227bb6df340>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ChatBubbleTypeEnum = "CAROUSEL_COMMERCE" | "CAROUSEL_FEED" | "COMMERCE" | "IMAGE" | "PREMIUM_VIDEO" | "TEXT" | "WIDE" | "WIDE_ITEM_LIST" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BrandMessageTemplateUpdateDialog_brandMessageTemplate$data = {
  readonly additionalContent: string | null;
  readonly adult: boolean;
  readonly buttons: ReadonlyArray<{
    readonly bizFormId: string | null;
    readonly linkAndroid: string | null;
    readonly linkIos: string | null;
    readonly linkMobile: string | null;
    readonly linkPc: string | null;
    readonly linkType: string;
    readonly name: string;
    readonly ordering: number | null;
  }>;
  readonly carousel: any | null;
  readonly chatBubbleType: ChatBubbleTypeEnum;
  readonly commerce: any | null;
  readonly content: string;
  readonly coupon: {
    readonly description: string;
    readonly linkAndroid: string | null;
    readonly linkIos: string | null;
    readonly linkMobile: string | null;
    readonly linkPc: string | null;
    readonly title: string;
  } | null;
  readonly header: string | null;
  readonly imageLink: string | null;
  readonly imageUrl: string | null;
  readonly templateCode: string;
  readonly templateName: string;
  readonly video: any | null;
  readonly wideItemList: any | null;
  readonly " $fragmentType": "BrandMessageTemplateUpdateDialog_brandMessageTemplate";
};
export type BrandMessageTemplateUpdateDialog_brandMessageTemplate$key = {
  readonly " $data"?: BrandMessageTemplateUpdateDialog_brandMessageTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTemplateUpdateDialog_brandMessageTemplate">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkIos",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkMobile",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkPc",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkAndroid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrandMessageTemplateUpdateDialog_brandMessageTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chatBubbleType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adult",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "additionalContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "carousel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wideItemList",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "video",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commerce",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandMessageButton",
      "kind": "LinkedField",
      "name": "buttons",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkType",
          "storageKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bizFormId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ordering",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandMessageCoupon",
      "kind": "LinkedField",
      "name": "coupon",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        (v3/*: any*/),
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandMessageTemplate",
  "abstractKey": null
};
})();

(node as any).hash = "cd2cd414bf88b4cc9462e797927c54bb";

export default node;
